module.exports = __webpack_public_path__ + "static/img/jbxx.b7c86a23.png";